// extracted by mini-css-extract-plugin
export default {"addon":"addon__uM1bj"};